export default {"src":"/_next/static/image/public/images/ic_checkbox_blank.3e6793f6b932617dd056fc2a19cf12ae.svg","height":20,"width":20};